import React from 'react';

import { FieldValues, Path, useFormContext } from 'react-hook-form';
import { Box } from 'shared/mui/Box';
import { WatchedTextInput } from 'shared/react-admin/Inputs';
import { CommissionsCalculationMethodInput } from 'shared/widgets/CommissionsCalculationMethodInput/CommissionsCalculationMethodInput';
import { useCalculationMethodVisibility } from 'shared/widgets/CommissionsCalculationMethodInput/hooks/useCalculationMethodVisibility';
import { useResetCalculationMethodOnHide } from 'shared/widgets/CommissionsCalculationMethodInput/hooks/useResetCalculationMethodOnHide';

export type CommissionsConditionsFormValues = {
  percent: string | null;
  fix: string | null;
  min: string | null;
  max: string | null;
};

export const CommissionsConditionsForm = <
  TFieldValues extends CommissionsConditionsFormValues & FieldValues,
>() => {
  const { watch, trigger } = useFormContext<TFieldValues>();

  const zeroed: boolean = watch('rate.zeroed' as Path<TFieldValues>);
  const isCalculationMethodVisible = useCalculationMethodVisibility();
  useResetCalculationMethodOnHide(isCalculationMethodVisible);

  const triggerPercentValidation = () =>
    trigger(['rate.percent', 'rate.fix', 'rate.max', 'rate.min'] as never);

  return (
    <>
      <Box display="flex" gap={3}>
        <WatchedTextInput
          disabled={zeroed}
          fullWidth
          label="Процент"
          onChange={triggerPercentValidation}
          size="small"
          source="rate.percent"
          sx={{ maxWidth: 'initial' }}
          variant="outlined"
          watchField="rate.zeroed"
        />
        <WatchedTextInput
          disabled={zeroed}
          fullWidth
          label="Фиксированная"
          onChange={triggerPercentValidation}
          size="small"
          source="rate.fix"
          sx={{ maxWidth: 'initial' }}
          variant="outlined"
          watchField="rate.zeroed"
        />
        <WatchedTextInput
          disabled={zeroed}
          fullWidth
          label="Максимальная"
          onChange={triggerPercentValidation}
          size="small"
          source="rate.max"
          sx={{ maxWidth: 'initial' }}
          variant="outlined"
          watchField="rate.zeroed"
        />
        <WatchedTextInput
          disabled={zeroed}
          fullWidth
          label="Минимальная"
          onChange={triggerPercentValidation}
          size="small"
          source="rate.min"
          sx={{ maxWidth: 'initial' }}
          variant="outlined"
          watchField="rate.zeroed"
        />
      </Box>
      {isCalculationMethodVisible && (
        <Box sx={{ mt: '10px' }}>
          <CommissionsCalculationMethodInput />
        </Box>
      )}
    </>
  );
};
